<template>
    <div id="app" class="d-flex flex-column vh-100">
        <Navbar></Navbar>
        <div class="container pb-3">
            <div class="row h-100">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <router-view/>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Navbar from "./components/Navbar";
    import Footer from "./components/Footer";

    export default {
        name: "app",
        components: {Navbar, Footer},
        mounted() {
            // this.$store.dispatch('init/setInitHttp',this);
        }
    }
</script>
<style>
    .vh-70 {
        height: 70vh !important;
    }

    .bg-navi {
        background-color: #1a2a3c !important;
    }

    .navbar-nav .nav-link.active {
        color: #cc6300 !important;
    }

    .text-orange {
        color: #cc6300 !important;
    }

    .btn-orange {
        color: #fff !important;
        background-color: #cc6300 !important;
        border-color: #cc6300 !important;
    }

    .btn-orange:not(.disabled):hover {
        color: #fff !important;
        background-color: #9f4e01 !important;
        border-color: #9f4e01 !important;
    }

</style>